module.exports = __webpack_public_path__ + "img/author.45f290dc.png";